import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageHero from '../components/layout/PageHero';
import Presentation from '../components/mining/Presentation';
import Activite from '../components/mining/Activite';
import Advantages from '../components/mining/Advantages';
import PhosphatesProject from '../components/mining/PhosphatesProject';

export default function Mines() {
  const { t } = useTranslation();

  // Mise à jour du titre de la page
  useEffect(() => {
    document.title = `${t('header.mining')} | SOCABEG`;
  }, [t]);
  return (
    <div className="w-full bg-white text-black">
      <PageHero 
        backgroundImage="/images/hero_mines.jpg"
        title={t('mining.hero.title')}
        subtitle={t('mining.hero.subtitle')}
        overlayColor="socabeg-blue"
        textPosition="left"
      />
      <div className="pt-8">
        <Presentation />
        <Activite />
        <Advantages />
        <PhosphatesProject />
      </div>
    </div>
  );
}
